import React, { useState } from "react";
import "./Haggling.css";

// Success Modal Component
const SuccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  
  return (
    <div className="haggling-modal-overlay">
      <div className="haggling-modal">
        <div className="haggling-modal-header">
          <h3>Success</h3>
          <button className="haggling-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="haggling-modal-content">
          <div className="haggling-success-icon">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="32" cy="32" r="32" fill="#F0FFEA" />
              <path d="M44 24L28 40L20 32" stroke="#16A34A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <p className="haggling-success-message">
            Congratulations! Both you and the seller have agreed on a final price.
          </p>
          <button className="haggling-modal-button" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default function Bidding() {
  const [showModal, setShowModal] = useState(false);
  const vesselInfo = {
    name: "ASG TUG NAVIGATOR",
    type: "AHTS 001",
    date: "21 Nov 2024",
    time: "1:00 PM"
  };

  return (
    <div className="haggling-container">
      {/* Vessel Information Header */}
      <div className="bidding-header-card">
        <div className="bidding-vessel-info">
          <h2>{vesselInfo.name}</h2>
          <div className="bidding-vessel-details">
            <span className="bidding-detail">{vesselInfo.type}</span>
            <span className="bidding-divider">•</span>
            <span className="bidding-detail">{vesselInfo.date}</span>
            <span className="bidding-divider">•</span>
            <span className="bidding-detail">{vesselInfo.time}</span>
          </div>
        </div>
      </div>
      
      {/* Bidding Card */}
      <div className="haggling-bid-card">
        <div className="haggling-bid-header">
          <div className="haggling-bid-info">
            <div className="haggling-bid-column">
              <div className="haggling-bid-label">Starting bid</div>
              <div className="haggling-bid-amount">$10,000<span className="haggling-bid-per">/day</span></div>
            </div>
            <div className="haggling-bid-divider"></div>
            <div className="haggling-bid-column">
              <div className="haggling-bid-label">Final bid</div>
              <div className="haggling-bid-amount">$10,500<span className="haggling-bid-per">/day</span></div>
            </div>
          </div>
          <div className="haggling-live-badge">
            <span className="haggling-live-dot"></span>
            Live
          </div>
        </div>
        
        <hr className="haggling-divider" />
        
        <div className="haggling-bid-content">
          <div className="haggling-price-section">
            <h3 className="haggling-section-title">Current Price</h3>
            <div className="haggling-current-price">
              <span className="haggling-dollar">$</span>
              <span className="haggling-price">10,000</span>
              <span className="haggling-per-day">/day</span>
            </div>
            
            <div className="haggling-price-buttons">
              <div className="haggling-button-row">
                <button className="haggling-price-button">+$250</button>
                <button className="haggling-price-button">+$500</button>
                <button className="haggling-price-button">+$1000</button>
                <button className="haggling-price-button">+$2000</button>
                <button className="haggling-price-button">+$5000</button>
              </div>
              <div className="haggling-button-row">
                <button className="haggling-price-button">-$250</button>
                <button className="haggling-price-button">-$500</button>
                <button className="haggling-price-button">-$1000</button>
                <button className="haggling-price-button">-$2000</button>
                <button className="haggling-price-button">-$5000</button>
              </div>
            </div>
            
            <button className="haggling-make-offer">Make offer</button>
            
            <div className="haggling-action-buttons">
              <button className="haggling-decline">Decline offer</button>
              <button className="haggling-accept" onClick={() => setShowModal(true)}>Accept offer</button>
            </div>
          </div>
          
          <div className="haggling-history-section">
            <h3 className="haggling-section-title">History</h3>
            <div className="haggling-history-list">
              <div className="haggling-history-item haggling-history-active">
                <div className="haggling-history-info">
                  <div className="haggling-history-text">Bid by me</div>
                  <div className="haggling-history-time">2 minutes ago</div>
                </div>
                <div className="haggling-history-amount">$10,000</div>
              </div>
              
              <div className="haggling-history-item">
                <div className="haggling-history-info">
                  <div className="haggling-history-text">Bid by Owner</div>
                  <div className="haggling-history-time">2 minutes ago</div>
                </div>
                <div className="haggling-history-amount">$10,000</div>
              </div>
              
              <div className="haggling-history-item">
                <div className="haggling-history-info">
                  <div className="haggling-history-text">Bid by me</div>
                  <div className="haggling-history-time">2 minutes ago</div>
                </div>
                <div className="haggling-history-amount">$10,000</div>
              </div>
              
              <div className="haggling-history-item">
                <div className="haggling-history-info">
                  <div className="haggling-history-text">Bid by Owner</div>
                  <div className="haggling-history-time">2 minutes ago</div>
                </div>
                <div className="haggling-history-amount">$10,000</div>
              </div>
              
              <div className="haggling-history-item">
                <div className="haggling-history-info">
                  <div className="haggling-history-text">Bid by me</div>
                  <div className="haggling-history-time">2 minutes ago</div>
                </div>
                <div className="haggling-history-amount">$10,000</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Success Modal */}
      <SuccessModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
} 